<template>
  <div class="mx-3 my-3">
    <div class="d-flex flex-wrap">
      <div
          v-for="role in roles"
          :key="role.key"
          class="col-12 col-xl-3 col-sm-5 border border-radius pr-4 pl-3 py-3 m-1 h-auto"
      >
        <div @click="notAllowedMessage(role)" class="custom-control custom-switch mb-2">
          <input
              type="checkbox"
              class="custom-control-input"
              :id="role.key + '_'"
              :name="role.key"
              v-model="role.value"
              :disabled="role.disable"
              @click="notAllowedMessage(role)"
              @change="toggleRole(role)"
          >
          <label class="custom-control-label font-weight-bold" :for="role.key + '_'">
            {{ role.name }}
          </label>
        </div>
        <div class="ml-4">
          <div v-for="permission in role.permissions" class="custom-control custom-switch">
            <div @click="notAllowedMessage(role)"
            >
              <input
                  :disabled="role.disable"
                  type="checkbox"
                  class="custom-control-input"
                  :id="role.key + '_' + permission.key"
                  :name="role.key + '_' + permission.key"
                  v-model="permission.value"
                  @change="togglePermission(role)"
              >
              <label class="custom-control-label" :for="role.key + '_' + permission.key">
                {{ permission.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button v-if="$can('change-access', 'user')" @click="submit" id="btn" class="btn btn-success my-3 mx-2">{{ $t('permissions.update') }}</button>
  </div>
</template>

<script>
import {RolesArray, RolesConstant} from "@/constants/RoleAndPermissions";
import $ from "jquery"
import {KTApp} from "@/plugins/core/app";
import {userService} from "@/common/api.service";
import toastr from "toastr";

export default {
  name: "permissions",
  props: {
    user_roles: {
      required: true,
    },
    user_permissions: {
      required: true,
    }
  },
  computed: {
    rolesArray() {
      return RolesArray
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
  },
  data() {
    return {
      roles: [],
      user_id: this.$route.params.hashid
    };
  },
  watch: {
    user_permissions: {
      immediate: true,
      handler() {
        return this.syncRolesWithApiPermissions();
      }
    },
  },
  methods: {
    notAllowedMessage(role) {
      if (role.disable === true) {
        return this.toastr.error('شما دسترسی لازم برای تغییر این دسترسی را ندارید')
      }
    },
    toggleRole(role) {
      role.permissions.forEach(permission => {
        permission.value = role.value; // sync all permissions with role checkbox
      });
    },
    togglePermission(role) {
      // If any permission is false, role.value should be false
      // If all permissions are true, role.value should be true
      role.value = role.permissions.every(permission => permission.value);
    },
    submit() {
      let btn = $('#btn')
      KTApp.progress(btn)

      userService.changeAccessV2(this.user_id, {roles: this.roles})
          .then(response => {
            this.toastr.success(response.data.message)
          })
          .catch(({response}) => {
            this.toastr.error(response.data.message)
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })
    },
    syncRolesWithApiPermissions() {
      let roles =  this.rolesArray.map(role => {
        const permissions = role.permissions.map(permission => {
          const hasPermission = this.user_permissions.includes(permission.key);
          return {
            ...permission,
            value: hasPermission
          };
        });

        const roleValue = this.user_roles.includes(role.key);

        if (roleValue) {
          permissions.every(p => p.value = true)
        }

        return {
          ...role,
          permissions,
          value: roleValue
        };
      })

      roles.forEach(role => {
        this.togglePermission(role);
      })

      if ( ! (this.$can('change-access', 'user'))) {
        roles.forEach(role => role.disable = true)
      }

      if ( ! (this.$can('change-monitoring-access', 'user'))) {
        roles.find(r => r.key === RolesConstant.MONITORING_MANAGER).disable = true
      }

      if ( ! (this.$can('change-accounting-access', 'user'))) {
        roles.find(r => r.key === RolesConstant.ACCOUNTING).disable = true
      }

      this.roles = roles
    },
  },
}
</script>

<style scoped>
.border-radius {
  border-radius: 10px;
}
</style>